module.exports = __webpack_public_path__ + "img/PAB.f764f7d4.svg";